import { Injectable } from '@angular/core';
import { DataFilterDisplayService } from '../interface';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DynamicStringDisplayService implements DataFilterDisplayService {
  getDisplay(value: unknown): Observable<string> {
    if (typeof value === 'string' && !!value) {
      return of(`<b>${value}</b>`);
    }
    if (typeof value === 'object') {
      const strValues = value as string[];
      if (strValues?.length > 0) {
        return of(`<b>${strValues.join(', ')}</b>`);
      }
    }
    return of('');
  }
}
